import tpl from '../templates/video.html';
import template from 'lodash/template';

const compiledTPL = template(tpl);

const urls = {
    youtube: 'https://www.youtube.com/embed/',
    vimeo: 'https://player.vimeo.com/video/'
};

export default class Video {
    constructor({el}) {
        this.el = el;
        this.video = this.getVideoDetails();
        this.nav = document.getElementById('primary-menu');
        this.open = false;
        
        this.bind();
    }

    getVideoDetails() {
        const href = this.el.getAttribute('href');
        const service = href.indexOf('youtube') !== -1 ? 'youtube' : 'vimeo';
        let id = '';

        if (service === 'youtube') {
            if (href.indexOf('embed') !== -1) {
                [,id] = href.match(/\/([a-zA-Z0-9-_]+)$/);
            }

            if (href.indexOf('watch?v=') !== -1) {
                [,id] = href.match(/v=([a-zA-Z0-9-_]+)/);
            }
        }

        if (service === 'vimeo') {
            [,id] = href.match(/([0-9]+)$/);
        }

        const url = `${urls[service]}${id}`;

        return {
            service,
            id,
            url
        };
    }

    bindOverlay() {
        const overlay = document.querySelector('.video-overlay');

        document.querySelector('.video-overlay .close').addEventListener('click', evt => {
            evt.preventDefault();

            overlay.parentNode.removeChild(overlay);
        });

        document.body.addEventListener('keyup', evt => {
            if (evt.keyCode === 27 && this.open) {
                this.open = false;

                overlay.parentNode.removeChild(overlay);
            }
        });
    }

    bind() {
        this.el.addEventListener('click', evt => {
            evt.preventDefault();

            const node = document.createElement('div');

            node.className = 'video-overlay';
            node.innerHTML = compiledTPL({
                video: this.video
            });

            document.body.appendChild(node);
            this.open = true;

            this.bindOverlay();
        });
    }
}
